(function () {
  if (window.mtCartTimerBound) return;
  window.mtCartTimerBound = true;

  var STORAGE_KEY = 'mt-cart-timer-end';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function readEnd(minutes) {
    var end = parseInt(window.sessionStorage.getItem(STORAGE_KEY) || '0', 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + minutes * 60 * 1000;
      window.sessionStorage.setItem(STORAGE_KEY, String(end));
    }
    return end;
  }

  function bind(root) {
    root.querySelectorAll('[data-mt-cart-timer]').forEach(function (timer) {
      if (timer.dataset.bound === 'true') return;
      timer.dataset.bound = 'true';

      var minutes = parseInt(timer.dataset.minutes, 10);
      if (!minutes || minutes < 1) minutes = 15;
      var value = timer.querySelector('[data-mt-cart-timer-value]');
      if (!value) return;

      function tick() {
        var left = Math.max(0, readEnd(minutes) - Date.now());
        var totalSeconds = Math.ceil(left / 1000);
        value.textContent = Math.floor(totalSeconds / 60) + ':' + pad(totalSeconds % 60) + '!';
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  function start() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  var observer = new MutationObserver(function () {
    bind(document);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
